<template>
  <HeadlessMenu as="div" class="inline-block text-left">
    <HeadlessMenuButton
      ref="referenceRef"
      class="flex size-8 items-center justify-center rounded-lg hover:bg-background-fg/3"
    >
      <IconHeroiconsBars3 class="size-10" />
    </HeadlessMenuButton>

    <Teleport to="body">
      <div ref="floatingRef" :style="floatingStyles">
        <Transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <HeadlessMenuItems
            class="mt-1 w-64 origin-top-right space-y-1 divide-y divide-background-fg/8 rounded-md bg-background p-1 text-background-fg shadow-lg ring-1 ring-black/5 focus:outline-none"
          >
            <div
              v-if="currentUser"
              class="w-full px-3 py-2 text-center text-sm font-medium"
            >
              <p class="line-clamp-1">
                {{ currentUser.email }}
              </p>
            </div>

            <div
              v-for="(
                section, sectionName
              ) in sidebarSections"
              :key="sectionName"
            >
              <HeadlessMenuItem
                v-for="item in section"
                :key="item.name"
              >
                <RouterLink
                  :to="{
                    name: item.name,
                  }"
                  class="block w-full px-3 py-2 text-center text-sm font-medium hover:bg-background-fg/3"
                  exact-active-class="text-primary bg-background-fg/2"
                >
                  {{ item.label }}
                </RouterLink>
              </HeadlessMenuItem>
            </div>

            <HeadlessMenuItem
              v-if="currentUser"
              as="button"
              class="flex w-full items-center justify-center px-3 py-2 text-center text-sm font-medium hover:bg-background-fg/3"
              @click="onLogout"
            >
              <IconHeroiconsArrowRightStartOnRectangle
                class="mr-2"
              />
              Log Out
            </HeadlessMenuItem>
          </HeadlessMenuItems>
        </Transition>
      </div>
    </Teleport>
  </HeadlessMenu>
</template>

<script setup lang="ts">
import {
  useFloating,
  offset,
  flip,
  size,
  autoUpdate,
} from "@floating-ui/vue"

const { currentUser } = useCurrentUser()

const sidebarSections = computed(
  () =>
    ({
      main: [
        {
          name: "requestCreate",
          label: "New Request",
        },
        {
          name: "usersIndex",
          label: "Staff",
        },
        {
          name: "paymentsIndex",
          label: "Payments",
        },
        {
          name: "customersIndex",
          label: "Customers",
        },
        {
          name: "servicesIndex",
          label: "Services",
        },
        { name: "help", label: "Help" },
      ],
      user: [
        {
          name: "changePassword",
          label: "Change Password",
        },
      ],
    }) as const
)

const referenceRef = ref(null)
const floatingRef = useTemplateRef("floatingRef")
const { floatingStyles } = useFloating(
  referenceRef,
  floatingRef,

  {
    placement: "bottom-end",
    strategy: "fixed",
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(4),
      flip(),
      size({
        apply({
          availableWidth,
          availableHeight,
          elements,
        }) {
          // Change styles, e.g.
          Object.assign(elements.floating.style, {
            maxWidth: `${Math.max(0, availableWidth)}px`,
            maxHeight: `${Math.max(0, availableHeight)}px`,
          })
        },
      }),
    ],
  }
)

const onLogout = () => logOut()
</script>
